<template>
  <div id="LoginFailPage">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">ADFS ERROR :(</h1>
          <h2 class="subtitle is-5">{{ adfsErrorMessage }}</h2>
          <b-button
            class="dtac-font"
            type="is-primaryt"
            @click.prevent="$router.push({ name: 'login' })"
            >Back to Login</b-button
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "LoginFailPage",
  data() {
    return {
      adfsErrorMessage: "Unknow Error"
    };
  },
  mounted() {
    if (this.$route.query.message) {
      this.adfsErrorMessage = this.$route.query.message.toString();
    }
  }
};
</script>
